// CORE (da inserire nel bundle principale)
import _scrollTo from "./_core/_scrollto.controls.ts";
_scrollTo.init();

import _animations from "./_engine/_animations.controls.ts";
_animations.init(undefined);

const parallax = document.querySelector("[animate-parallax]");
if (parallax) {
    import("./_engine/_parallax.controls.ts").then(({ default: _parallax }) => {
        _parallax.init(0.5);
    });
}

// FORMS
const forms = document.getElementsByTagName("form");
if (forms && forms.length > 0) {
    import("./_formValidation/_validation.bootstrapper.ts").then(({ default: _validationBootstrapper }) => {
        _validationBootstrapper.init(forms);
    });
    import("./_core/_floatLabels.ts").then(({ default: _floatLabels }) => {
        _floatLabels.init(document.querySelectorAll(".float-label"));
    });
}

// LIBRARIES
const swiper = document.querySelector(".swiper");
if (swiper) {
    import("./_engine/_swiper.controls.ts").then(({ default: _swiperControls }) => {
        _swiperControls.init();
    });
}

const lightbox = document.querySelector("[data-fslightbox]");
if (lightbox) {
    // @ts-ignore
    import("fslightbox");
}

const loadMore = document.querySelectorAll<HTMLButtonElement>("button[load-more]");
if (loadMore.length > 0) {
    import("./_engine/_loadMore.controls.ts").then(({ default: _loadMore }) => {
        loadMore.forEach((button) => {
            _loadMore.init(button);
        });
    });
}

// BLOCKS
const accordions = document.querySelectorAll(".accordion-container");
if (accordions && accordions.length > 0) {
    import("./_blocks/_accordion.ts").then(({ default: _accordion }) => {
        _accordion.init(accordions);
    });
}

const accordionOrizzontaleList = document.querySelectorAll(".accordion-orizzontale-container");
if (accordionOrizzontaleList && accordionOrizzontaleList.length > 0) {
    import("./_blocks/_accordionOrizzontale.ts").then(({ default: _accordionOrizzontale }) => {
        _accordionOrizzontale.init(accordionOrizzontaleList);
    });
}

const testoScorrimentoList = document.querySelectorAll(".testo-scorrimento");
if (testoScorrimentoList && testoScorrimentoList.length > 0) {
    import("./_blocks/_testoScorrimento.ts").then(({ default: _testoScorrimento }) => {
        _testoScorrimento.init(testoScorrimentoList);
    });
}

// PAGES
const tagProgetti = document.querySelector(".lista-progetti .tabs");
if (tagProgetti) {
    import("./_pages/_listatoProgetti.ts").then(({ default: listatoProgetti }) => {
        listatoProgetti.init(tagProgetti);
    });
}

// VARIE ED EVENTUALI

// Da attivare solo nel caso in cui nel sito sono presenti fasce
// che usano il pin dello scroll-trigger, assieme a fasce che cambiano di dimensione
const needsResizeChecker = false;
if (needsResizeChecker) {
    import("./_core/_resizeChecker.ts").then(({ default: _resizeChecker }) => {
        _resizeChecker.init();
    });
}

// MENU CONTROLS

const menuBarDesktop = document.querySelector<HTMLElement>(".menu.desktop .menu-bar");
if (menuBarDesktop) {
    import("./_engine/_menuDesktop.controls.ts").then(({ default: _menuDesktopControls }) => {
        _menuDesktopControls.init(menuBarDesktop);
    });
}
const menuBarMobile = document.querySelector<HTMLElement>(".menu.mobile .menu-bar");
const menuContentMobile = document.querySelector<HTMLElement>(".menu.mobile .menu-content");
const menuButtonMobile = menuBarMobile?.querySelector<HTMLElement>(".hamburger");
if (menuBarMobile && menuContentMobile && menuButtonMobile) {
    import("./_engine/_menuMobile.controls.ts").then(({ default: _menuMobileControls }) => {
        _menuMobileControls.init(menuBarMobile, menuContentMobile, menuButtonMobile);
    });
}
